import { DefaultIconProps } from "./default-icon/default-icon-props";
import { DefaultIcon } from "./default-icon/default-icon"

export const RankingIcon = (props: DefaultIconProps) => {
    return (
        <>
            <DefaultIcon tipo={props.tipo} class={props.class} style={props.style} fill={props.fill}>
                <path d="M 34 4 L 34 50 L 48 50 L 48 4 Z M 36 6 L 46 6 L 46 48 L 36 48 Z M 2 17 L 2 50 L 16 50 L 16 17 Z M 4 19 L 14 19 L 14 48 L 4 48 Z M 18 28 L 18 50 L 32 50 L 32 28 Z M 20 30 L 30 30 L 30 48 L 20 48 Z"></path>
            </DefaultIcon>
        </>
    );
};